/*
 * @name: 自定义组件渲染组件
 */
import * as React from 'react';
import { useState } from 'react';
import { PopEdit } from '@whalecloud/fdx';
import { RemoteComponent } from '@components/RemoteComponent';
import { tableRegExp } from '@utils/util';

/**
 * @param  {Object} element 当前元素
 * @param  {} value   组件值，如果自定义组件是表单控件，则在使用时Form会传入该参数，组件需要接收
 * @param  {Function} onChange 组件值改变触发的方法，如果自定义组件是表单控件，则在使用时Form会传入该参数，组件需要接收
 */
const ParticiPantElement = ({ element, value, onChange }) => {
  const { settings = {}, className } = element.data;
  let { formItemSettings = {} } = element.data;
  const { defaultValue, modalProps: { render = '' }, allowClear } = formItemSettings;
  const { width } = settings;
  value = value || formItemSettings.value;
  const [curVal, setCurVal] = useState(value);

  const handleOk = (val: any) => {
    value = val
  }
  const handleChange = val => {
    onChange(val)
    if (allowClear) {
      setCurVal(val)
    }
  }
  const modalProps = {
    ...formItemSettings?.modalProps,
    onOk: handleOk,
  }
  const inputProps = {
    ...formItemSettings?.inputProps,
    allowClear
  }
  formItemSettings = {
    ...formItemSettings,
    value: allowClear ? curVal : value,
    defaultValue,
    onChange: handleChange,
    modalProps: { ...modalProps },
    inputProps
  }
  if (allowClear){
    formItemSettings.onClear = () => setCurVal({})
  }
  if (render) {
    // 通过远程组件渲染 Modal
    const ModalComponent = (props: any) => <RemoteComponent url={render} {...props} />

    const hanlderComponentRender = (handleValue: any) => {
      const { value, defaultValue, dataTextField, dataValueField } = formItemSettings;
      const ModalComponentProps = { value, defaultValue, dataTextField, dataValueField }
      return (
        <ModalComponent handleValue={handleValue} {...ModalComponentProps} />
      )
    }
    formItemSettings.modalProps.render = (handleValue) => hanlderComponentRender(handleValue)
  }

  return (
    <PopEdit style={{ width: width.value }} {...formItemSettings} className={className} />
  );
};

export default ParticiPantElement;
